import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const getAdminEmployerProjects = async () => {
  const signedRequest = await createSignedGetRequest({
    apiPath: 'admin/employer-projects',
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
